import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetEmailCalendarStatuses as GetEmailCalendarStatusesQuery,
    UserEmailCalendarStatusesFragment,
} from 'nutshell-graphql-types';

import GET_EMAIL_CALENDAR_STATUSES from '../queries/get-email-calendar-statuses.graphql';

export const useGetEmailCalendarStatuses = (
    skip = false
): {
    userEmailCalendarStatuses: UserEmailCalendarStatusesFragment | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetEmailCalendarStatusesQuery,
        Record<any, any>
    >(GET_EMAIL_CALENDAR_STATUSES, {
        fetchPolicy: 'cache-and-network',
        skip,
    });

    return {
        userEmailCalendarStatuses: data && data.loggedInUser,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
